import { Link } from 'react-router-dom'
import { Botao } from '../../../components/Botao'
import { Explicacao } from '../../../components/Explicacao'
import { IconeImprimir, IconeSeta } from '../../../components/Icones'
import { TEXTOS } from '../../../lib/glossario'

/**
 * A barra de tela do termo — tudo o que NÃO sai no papel.
 *
 * `print:hidden` e não uma classe do `trp.css`: esta barra é interface da aplicação, feita com os
 * componentes da casa. A exceção do CSS dedicado vale para o documento, e o jeito de saber se algo
 * pertence ao documento é perguntar se sai impresso.
 *
 * Imprimir é `<button>` (é ação nesta página) e voltar é `<Link>` (é endereço, e transformá-lo em
 * botão tiraria o "abrir em nova aba" de quem usa o navegador).
 *
 * @param props a competência e se já há documento a imprimir
 * @returns a barra de controles
 */
export function ControlesDoTrp({ competencia, pronto }: { competencia: string; pronto: boolean }) {
  const t = TEXTOS.trp
  return (
    <section
      aria-label="Ações do termo"
      className="sticky top-0 z-10 border-b border-slate-300 bg-white px-4 py-3 shadow-sm print:hidden"
    >
      <div className="mx-auto flex max-w-[210mm] flex-wrap items-center gap-x-4 gap-y-3">
        <Link
          to={`/fiscalizacao?competencia=${competencia}`}
          className="inline-flex items-center gap-1.5 text-sm text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
        >
          <IconeSeta className="h-4 w-4 rotate-180" />
          {t.voltar}
        </Link>

        <Botao aparencia="primario" onClick={() => window.print()} disabled={!pronto}>
          <IconeImprimir className="h-4 w-4" />
          {t.imprimir}
        </Botao>

        <p className="min-w-64 flex-1 text-sm text-slate-600">
          <Explicacao termo="trp" /> {t.ajudaDaBarra}
        </p>
      </div>
    </section>
  )
}
